module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-stone-path.132365c3.png";